var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 2,
    width: 6,
    height: 11,
    rx: 3,
    fill: "#181A1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8C6.55228 8 7 8.44772 7 9V10C7 12.7614 9.23858 15 12 15C14.7614 15 17 12.7614 17 10V9C17 8.44772 17.4477 8 18 8C18.5523 8 19 8.44772 19 9V10C19 13.5265 16.3923 16.4439 13 16.9291V20H18C18.5523 20 19 20.4477 19 21C19 21.5523 18.5523 22 18 22L6 22C5.44772 22 5 21.5523 5 21C5 20.4477 5.44772 20 6 20L11 20V16.9291C7.60771 16.4439 5 13.5265 5 10V9C5 8.44772 5.44772 8 6 8Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.3b1f53390abc589d2389ecf6e08ce236.svg";
export { ForwardRef as ReactComponent };